import { Component, OnInit } from "@angular/core";
import { Store, Action } from "@ngrx/store";
import { TutorAllocation } from "@models/tutor-allocation";
import { AppState } from "@store/app-state"
import { Course } from "@models/course";
import { Observable } from "rxjs/Observable";
import { TutorAllocationsStore } from "@store/tutor-allocations";
import { ModalService, ModalConfig } from "@services/modal";
import {
  FETCH_TUTOR_ALLOCATIONS,
  POPULATE_EDITABLE_TUTOR_ALLOCATION
} from "@reducers/tutor-allocations";
import { TutorAllocationFormComponent } from "./tutor-allocation-form";
import { MatrixClassEffects } from "@reducers/effects/matrix-class";
import {
  FETCH_TEACHERS,
  POPULATE_TEACHERS
} from "@reducers/matrix-class";

interface TutorAllocationsByFaculty {
  faculty: string,
  tutorAllocations: TutorAllocation[],
}

@Component({
  selector: 'tutor-allocations',
  templateUrl: './tutor-allocations.pug',
})
export class TutorAllocationsComponent implements OnInit {

  public tutorAllocationsStore: Observable<TutorAllocationsStore>
  public tutorAllocations: TutorAllocation[]

  constructor(
    private store: Store<AppState>,
    private matrixClassEffects: MatrixClassEffects,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.tutorAllocationsStore = this.store.select("tutorAllocationsReducer")

    this.tutorAllocationsStore.subscribe((s: TutorAllocationsStore) => {
      this.tutorAllocations = s.tutorAllocations
    })

    this.populateTutorAllocations()
  }

  populateTutorAllocations() {
    this.store.dispatch({ type: FETCH_TUTOR_ALLOCATIONS })
  }

  clickedNewTutorAllocation() {
    const ta = new TutorAllocation()
    this.store.dispatch({ type: POPULATE_EDITABLE_TUTOR_ALLOCATION, payload: ta })
    this.modalService.showModal(new ModalConfig(TutorAllocationFormComponent))
  }

  clickedEditTutorAllocation(ta: TutorAllocation) {
    this.store.dispatch({ type: POPULATE_EDITABLE_TUTOR_ALLOCATION, payload: ta })
    this.modalService.showModal( new ModalConfig(TutorAllocationFormComponent, { isEditing: true }))
  }

  getTutorAllocationsByFaculty(): TutorAllocationsByFaculty[] {
    let result: TutorAllocationsByFaculty[] = [0, 1, 2].map((i) => {
      return { faculty: Course.FACULTIES[i], tutorAllocations: [] }
    })

    result.forEach((tbf, i) => {
      this.tutorAllocations.forEach((ta) => {
        if (ta.courses.find(c => c.faculty == i)) {
          const target = result.find((tbf) => {
            return tbf.faculty == Course.FACULTIES[i]
          })
          target.tutorAllocations.push(ta)
        }
      })
    })

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/tutor-allocations.ts